import React, { Fragment, Component } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { every } from 'lodash';
import plural from 'pluralize';
import MarkTankCleanModal from '~/containers/markTankCleanModal/markTankCleanModal';
import MarkTankEmptyModal from '~/containers/markTankEmptyModal/markTankEmptyModal';

const initialState = {
  isOpen: false,
  markTankAsCleanModalOpen: false,
  markTankAsEmptyModalOpen: false
};

export default class TankListActions extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  toggleModal = name => {
    this.setState({
      [`${name}Open`]: !this.state[`${name}Open`]
    });
  };

  onActionSuccess = () => {
    this.setState(initialState);
    this.props.refreshList();
  };

  renderConfirmCleaned = () => {
    const { selectedTanks } = this.props;
    const allRequireCleaning = every(selectedTanks, l => l.status === 'REQUIRES_CLEANING');

    return (
      allRequireCleaning && (
        <DropdownItem onClick={() => this.toggleModal('markTankAsCleanModal')}>
          Mark {plural('tank', selectedTanks.length)} as clean
        </DropdownItem>
      )
    );
  };

  renderConfirmEmpty = () => {
    const { selectedTanks } = this.props;

    return (
      selectedTanks.length && (
        <DropdownItem onClick={() => this.toggleModal('markTankAsEmptyModal')}>
          Mark {plural('tank', selectedTanks.length)} as empty
        </DropdownItem>
      )
    );
  };

  render() {
    const { selectedTanks } = this.props;
    if (!selectedTanks.length) {
      return null;
    }

    const { markTankAsCleanModalOpen, markTankAsEmptyModalOpen } = this.state;

    return (
      <Fragment>
        <ButtonDropdown className="ml3 input-height" isOpen={this.state.isOpen} toggle={this.onToggle}>
          <DropdownToggle caret>Actions</DropdownToggle>
          <DropdownMenu>{this.renderConfirmCleaned()}</DropdownMenu>
          <DropdownMenu>{this.renderConfirmEmpty()}</DropdownMenu>
        </ButtonDropdown>
        <MarkTankCleanModal
          tanks={selectedTanks}
          isOpen={markTankAsCleanModalOpen}
          onSuccess={this.onActionSuccess}
          onToggle={() => this.toggleModal('markTankAsCleanModal')}
          refetchQueries={['tanks']}
        />
        <MarkTankEmptyModal
          tanks={selectedTanks}
          isOpen={markTankAsEmptyModalOpen}
          onSuccess={this.onActionSuccess}
          onToggle={() => this.toggleModal('markTankAsEmptyModal')}
          refetchQueries={['tanks']}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/tankListActions/tankListActions.jsx